import { render, staticRenderFns } from "./TeleMarketSeat.vue?vue&type=template&id=bbc7c556&scoped=true"
import script from "./TeleMarketSeat.vue?vue&type=script&lang=js"
export * from "./TeleMarketSeat.vue?vue&type=script&lang=js"
import style0 from "./TeleMarketSeat.vue?vue&type=style&index=0&id=bbc7c556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc7c556",
  null
  
)

export default component.exports